import i18next from 'i18next';

import utilsXLS from '@commons/utils/makeXLS';

const getSupplierProfileColumns = () => [
  {
    propertyKey: 'supplierName',
    name: i18next.t('_BACKEND_TRANSLATIONS.SUPPLIER_PROFILES.IMPORTS.SUPPLIER'),
  },
  {
    propertyKey: 'name',
    name: i18next.t('_BACKEND_TRANSLATIONS.SUPPLIER_PROFILES.IMPORTS.SUPPLIER_PROFILE_NAME'),
  },
  {
    propertyKey: 'contactName',
    name: i18next.t('_BACKEND_TRANSLATIONS.SUPPLIER_PROFILES.IMPORTS.CONTACT_NAME'),
  },
  {
    propertyKey: 'email1',
    name: i18next.t('ADMIN.SUPPLIERS.SUPPLIER_PROFILE_CONTACT_ORDERS_EMAILS'),
  },
  {
    propertyKey: 'email2',
    name: i18next.t('ADMIN.SUPPLIERS.SUPPLIER_PROFILE_CONTACT_CREDITS_EMAILS'),
  },
  {
    propertyKey: 'bccEmails',
    name: i18next.t('ADMIN.SUPPLIERS.SUPPLIER_PROFILE_CONTACT_BCC_EMAILS'),
  },
  {
    propertyKey: 'telephone',
    name: i18next.t('GENERAL.PHONE'),
  },
  {
    propertyKey: 'address',
    name: i18next.t('ADMIN.SUPPLIERS.LIST_COLUMN_ADDRESS'),
  },
  {
    propertyKey: 'postCode',
    name: i18next.t('ADMIN.SUPPLIERS.LIST_COLUMN_POSTAL_CODE'),
  },
  {
    propertyKey: 'city',
    name: i18next.t('ADMIN.SUPPLIERS.LIST_COLUMN_CITY'),
  },
  {
    propertyKey: 'country',
    name: i18next.t('ADMIN.SUPPLIERS.LIST_COLUMN_COUNTRY'),
  },
  {
    propertyKey: 'timezone',
    name: i18next.t('GENERAL.TIMEZONE'),
  },
  {
    propertyKey: 'orderMinAmount',
    name: i18next.t('_BACKEND_TRANSLATIONS.SUPPLIER_PROFILES.IMPORTS.MINIMUM_ORDER_AMOUNT'),
  },
  {
    propertyKey: 'orderMinUnit',
    name: i18next.t('ADMIN.SUPPLIERS.SUPPLIER_PROFILE_MINIMUM_ORDER'),
  },
  {
    propertyKey: 'minOrderWeight',
    name: i18next.t('ADMIN.SUPPLIERS.SUPPLIER_PROFILE_MINIMUM_ORDER_WEIGHT'),
  },
  {
    propertyKey: 'orderTimeLimit',
    name: i18next.t('ORDERS.ORDERS.FORM_INFO_MODAL_ORDERING_TIME_DEADLINE'),
  },
  {
    propertyKey: 'deliveryDays',
    name: i18next.t('ORDERS.ORDERS.FORM_INFO_MODAL_DAY_OF_DELIVERY'),
  },
  {
    propertyKey: 'deliveryLeadTimes',
    name: i18next.t('ADMIN.SUPPLIERS.SUPPLIER_PROFILE_DELIVERY_TIME_CHOICE'),
  },
];

/**
 * Build the supplier profiles sheet of the suppliers export
 *
 * @param {Array} supplierProfiles - The supplier profiles returned by the API
 * @return {Object} The sheet to pass to makeXLS
 */
export const createSupplierProfilesSheet = (supplierProfiles) =>
  utilsXLS.generateDefaultSheet(
    i18next.t('_BACKEND_TRANSLATIONS.SUPPLIER_PROFILES.IMPORTS.SHEET_NAME'),
    getSupplierProfileColumns(),
    supplierProfiles,
  );
